module.exports = __webpack_public_path__ + "img/gate_timedout.a682700.svg";